export default __webpack_public_path__ + "static/media/TheNewYear_03.c4c33405.png";